import { css } from '@emotion/react';
import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';
export const containerStyle = css `
  font-family: Charlie Text, sans-serif;
  box-sizing: border-box;
  width: 400px;
  min-height: 300px;
  padding: ${wplToken('space.300')};
`;
export const spinnerContainerStyle = css `
  width: 400px;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const headerContainerStyle = css `
  display: flex;
  align-items: center;
  margin-bottom: ${wplToken('space.100')};

  svg {
    margin-bottom: 0px !important;
  }
`;
export const headerStyle = css `
  display: inline-block;
  margin: 0 0 0 ${wplToken('space.100')};
  font-family: Charlie Display, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.3px;
`;
export const descriptionStyle = css `
  font-size: 14px;
  line-height: 18px;
`;
export const dividerStyle = css `
  border-bottom: 1px solid ${getColor('n50')};
  margin: ${wplToken('space.300')} 0;
`;
export const footerContainerStyle = css `
  font-family: Charlie Display, sans-serif;
  font-size: 22px;
  line-height: 24px;
  display: flex;

  div {
    flex: 1 1 auto;
  }
`;
export const totalValueStyle = css `
  font-weight: 500;
  text-align: right;
`;
export const taxSubtextStyle = css `
  font-size: 10px;
  line-height: 20px;
  text-align: right;
  margin-bottom: ${wplToken('space.200')};
  color: ${getColor('n200')};
`;
export const buttonWrapper = css `
  display: flex;
  justify-content: center;

  a {
    font-weight: 500 !important;
  }
`;
//# sourceMappingURL=entitlements-popup.styles.js.map